import { useState } from 'react';

const ALERT_TIMEOUT_MS = 5000;

export const useFacilityUserAlerts = () => {
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const showSuccessMessage = (message) => {
    setSuccessMessage(message);
    setShowSuccessAlert(true);
    setTimeout(() => setShowSuccessAlert(false), ALERT_TIMEOUT_MS);
  };

  const showErrorMessage = (message) => {
    setErrorMessage(message);
    setShowErrorAlert(true);
    setTimeout(() => setShowErrorAlert(false), ALERT_TIMEOUT_MS);
  };

  const handleSuccessClose = () => {
    setShowSuccessAlert(false);
    setSuccessMessage('');
  };

  const handleErrorClose = () => {
    setShowErrorAlert(false);
    setErrorMessage('');
  };

  return {
    showSuccessAlert,
    successMessage,
    showErrorAlert,
    errorMessage,
    showSuccessMessage,
    showErrorMessage,
    handleSuccessClose,
    handleErrorClose,
  };
};
